import { useContext, useState, useRef } from 'react';
import { Modal, Button, Input, Form, Select, Radio, Space, Switch } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import http, { InverterContext } from '../../../Http';
import utils from '../../../utils';
import InputPrefix from '../../../utils/InputPrefix';
import { useTranslation } from 'react-i18next';

function InverterAdd(props) {
    const { t } = useTranslation();
    const setTip = useContext(utils.tipContext);

    const { show, onClose } = props;

    const [form] = Form.useForm();

    const [distributorSelectOptions, setDistributorSelectOptions] = useState([]);
    const [timezoneSelectOptions, setTimezoneSelectOptions] = useState([]);
    const [inverterSelectOptions, setInverterSelectOptions] = useState([]);
    const [parallelMasterSelectOptions, setParallelMasterSelectOptions] = useState([]);
    const [isSungery, setIsSungery] = useState(false);  //是否是阳台经济
    const [addToParallel, setAddToParallel] = useState(false);  //是否添加并机信息
    const [masterOrSlave, setMasterOrSlave] = useState(0);  //是否是并机从机

    const refTimerDistributorSearcher = useRef(null);
    const refDistributorSearchValue = useRef(null);
    const refTimerTimezoneSearcher = useRef(null);
    const refTimezoneSearchValue = useRef(null);
    const refTimerInverterSearcher = useRef(null);
    const refInverterSearchValue = useRef(null);
    const refTimerParallelMasterSearcher = useRef(null);
    const refParallelMasterSearchValue = useRef(null);
    const [inverterModelSelectOptions, setInverterModelSelectOptions] = useState([]);
    const refTimerInverterModelSearcher = useRef(null);
    const refInverterModelSearchValue = useRef(null);

    const handleRefreshInverter = useContext(InverterContext);

    const handleCancle = () => {
        onClose(null);
        form.resetFields();
        setIsSungery(false);
        setAddToParallel(false);
        setMasterOrSlave(0);
    }

    const handleSubmit = async () => {
        const ps = await form.validateFields().catch(() => { return null });

        if (ps === null) {
            return;
        }

        ps.Model = ps.Model || "";
        ps.DistributorName = ps.DistributorName || "";
        ps.Timezone = ps.Timezone || "";
        ps.Batteries = ps.Batteries && ps.Batteries.length > 0 ? ps.Batteries.map(v => v.DeviceSN).join(";") : "";
        ps.Batteries = encodeURIComponent(ps.Batteries)
        ps.MasterOrSlave = ps.MasterOrSlave || 0;
        ps.ParallelMasterID = ps.ParallelMasterID || "";
        ps.SlaveInverters = ps.SlaveInverters && ps.SlaveInverters.length > 0 ? ps.SlaveInverters.map(v => v.SN).join(";") : "";
        ps.SlaveInverters = encodeURIComponent(ps.SlaveInverters);

        const resp = await http.post("integrated-inverter/add", ps).then(async (r) => {
            return await r.json();
        }).catch((e) => {
            return null;
        });

        try {
            if (resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("add error") });
                return
            }

            setTip({ open: true, severity: 'success', msg: t('add success') });

            ps.ID = resp.data.ID;
            ps.CreateTime = resp.data.CreateTime;
            ps.Protocol = resp.data.Protocol;
            form.resetFields();
            setIsSungery(false);
            setAddToParallel(false);
            setMasterOrSlave(0);
            handleRefreshInverter();
            onClose(ps);
        } catch (e) {
            setTip({ open: true, severity: "error", msg: t("add error") });
        }
    }

    const handleSearchDistributor = (v) => {
        if (refTimerDistributorSearcher.current != null) {
            clearTimeout(refTimerDistributorSearcher.current);
        }
        refDistributorSearchValue.current = v;

        refTimerDistributorSearcher.current = setTimeout(async () => {
            const resp = await http.post("distributor/name/list", {
                Value: v,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[DeviceAdd]", e);
                return null;
            });

            if (refDistributorSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load distributor list error") });
                    return;
                }

                const ls = resp.data.map(({ Name, ID }) => {
                    return (
                        <Select.Option key={ID} value={Name}>{Name}</Select.Option>
                    );
                });
                setDistributorSelectOptions(ls);
            } catch (e) {
                console.log("[DeviceAdd]", e);

                setTip({ open: true, severity: "error", msg: t("load distributor list error") });
            }
        }, 300);
    }

    const handleSearchInverter = (v) => {
        if (refTimerInverterSearcher.current != null) {
            clearTimeout(refTimerInverterSearcher.current);
        }
        refInverterSearchValue.current = v;

        refTimerInverterSearcher.current = setTimeout(async () => {
            const resp = await http.post("integrated-inverter/sn/list", {
                SN: v,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (refInverterSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load inverter list error") });
                    return;
                }

                const ls = resp.data.map(({ SN, ID }) => {
                    return (
                        <Select.Option key={ID} value={SN}>{SN}</Select.Option>
                    );
                });
                setInverterSelectOptions(ls);
            } catch (e) {
                setTip({ open: true, severity: "error", msg: t("load inverter list error") });
            }
        }, 300);
    }

    //search parallel master 
    const handleSearchParallelMaster = (v) => {
        if (refTimerParallelMasterSearcher.current != null) {
            clearTimeout(refTimerParallelMasterSearcher.current);
        }
        refParallelMasterSearchValue.current = v;

        refTimerParallelMasterSearcher.current = setTimeout(async () => {
            const resp = await http.post("integrated-inverter/parallel-master/list", {
                Value: v,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (refParallelMasterSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load parallel master list error") });
                    return;
                }

                const ls = resp.data.map(({ SN, ID }) => {
                    return (
                        <Select.Option key={ID} value={ID}>{SN}</Select.Option>
                    );
                });
                setParallelMasterSelectOptions(ls);
            } catch (e) {
                setTip({ open: true, severity: "error", msg: t("load parallel master list error") });
            }
        }, 300);
    }

    const handleSearchInverterModel = (v) => {
        if (refTimerInverterModelSearcher.current != null) {
            clearTimeout(refTimerInverterModelSearcher.current);
        }
        refInverterModelSearchValue.current = v;

        refTimerInverterModelSearcher.current = setTimeout(async () => {
            const resp = await http.post("integrated-inverter/model/list", {
                Value: v
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (refInverterModelSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load inverter model error") });
                    return;
                }

                const ls = resp.data.map(({ ID, Name }) => {
                    return (
                        <Select.Option key={ID} value={Name}>{Name}</Select.Option>
                    );
                });
                setInverterModelSelectOptions(ls);
            } catch (e) {
                setTip({ open: true, severity: "error", msg: t("load inverter model error") });
            }
        }, 300);
    }

    const handleSearchTimezone = (v) => {
        if (refTimerTimezoneSearcher.current != null) {
            clearTimeout(refTimerTimezoneSearcher.current);
        }
        refTimezoneSearchValue.current = v;


        refTimerTimezoneSearcher.current = setTimeout(async () => {
            const resp = await http.post("timezone/list", {
                Timezone: v,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[DeviceAdd]", e);
                return null;
            });

            if (refTimezoneSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load timezone list error") });
                    return;
                }

                const ls = resp.data.map(({ ZoneName, GmtOffset }) => {
                    var n = parseInt(GmtOffset);
                    var tz = "UTC+";
                    if (n < 0) {
                        tz = "UTC-";
                        n = Math.abs(n);
                    }
                    tz += Math.floor(n / 3600).toString().padStart(2, "0") + ":" + Math.floor((n % 3600) / 60).toString().padStart(2, "0")
                    return (
                        <Select.Option key={ZoneName} value={ZoneName}>{ZoneName}({tz})</Select.Option>
                    );
                });
                setTimezoneSelectOptions(ls);
            } catch (e) {
                console.log("[Device-Adder]", e);

                setTip({ open: true, severity: "error", msg: t("load device list error") });
            }
        }, 300);
    }

    return (<Modal
        title={t("Add Inverter")}
        visible={show}
        cancelText={t("Cancel")}
        okText={t("Submit")}
        mask={true}
        maskClosable={false}
        width={520}
        onCancel={handleCancle}
        onOk={handleSubmit}
        footer={[
            <Button
                key="Clear"
                shape="round"
                onClick={() => {
                    form.resetFields();
                }}
            >{t("Clear")}</Button>,
            <Button key="Cancel" shape="round" onClick={handleCancle}>{t("Cancel")}</Button>,
            <Button key="Submit" shape="round" type="primary" onClick={handleSubmit}>{t("Submit")}</Button>
        ]}
    >
        <Form
            labelAlign="left"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 24 }}
            form={form}
        >
            <Form.Item
                name="SN"
                label=""
                rules={[{ required: true }]}
            >
                <Input prefix={<InputPrefix label={t("SN")} required />} placeholder={t("Enter Inverter SN")} style={{ borderRadius: '20px' }} />
            </Form.Item>
            <Input.Group compact>
                <Button><span style={{ color: 'red', verticalAlign: 'middle' }}>*&nbsp;</span>{t("Model")}</Button>
                <Form.Item
                    name="Model"
                    label=""
                    rules={[{ required: true }]}
                    style={{ width: 'calc(100% - 80px' }}
                >
                    <Select
                        showSearch
                        placeholder={t("Enter Inverter Model")}
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={handleSearchInverterModel}
                        onChange={value => {
                            setIsSungery(value == 'ALL in one-D2.4kW')
                            setAddToParallel(false)
                            setMasterOrSlave(0)
                        }}
                    >{inverterModelSelectOptions}</Select>
                </Form.Item>
            </Input.Group>
            <Input.Group compact>
                <Button>{t("Distributor")}</Button>
                <Form.Item
                    name="DistributorName"
                    label=""
                    style={{ width: 'calc(100% - 98px' }}
                >
                    <Select
                        showSearch
                        placeholder={t("Enter Distributor Name")}
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={handleSearchDistributor}
                    >{distributorSelectOptions}</Select>
                </Form.Item>
            </Input.Group>
            <Input.Group compact>
                <Button><span style={{ color: 'red', verticalAlign: 'middle' }}>&nbsp;</span>{t("Timezone")}</Button>
                <Form.Item
                    name="Timezone"
                    label=""
                    style={{ width: 'calc(100% - 96px' }}
                >
                    <Select
                        showSearch
                        placeholder={t("Timezone")}
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={handleSearchTimezone}
                    >{timezoneSelectOptions}</Select>
                </Form.Item>
            </Input.Group>

            <Form.Item label={t("Batteries")}>
                <Form.List name="Batteries" label={t("Batteries")}>
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map(({ key, name, fieldKey, ...restField }) => (
                                <Space key={key} style={{ display: 'flex', marginBottom: 2 }} align="baseline">
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'DeviceSN']}
                                        fieldKey={[fieldKey, 'DeviceSN']}
                                        rules={[{ required: true, message: t('Missing Battery SN') }]
                                        }
                                    >
                                        <Input placeholder={t("Enter Battery SN")} style={{ width: 300 }} />
                                    </Form.Item>
                                    <MinusCircleOutlined onClick={() => remove(name)} />
                                </Space>
                            ))}
                            <Form.Item>
                                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />} style={{ borderRadius: '20px' }}>
                                    {t("Add Battery")}
                                </Button>
                            </Form.Item>
                        </>
                    )}
                </Form.List>
            </Form.Item>

            {isSungery &&
                <Form.Item
                    name="AddToParallel"
                    label={t("Add to Parallel")}
                >
                    <Switch onChange={(checked) => setAddToParallel(checked)} value={addToParallel} />
                </Form.Item>
            }
            {isSungery && addToParallel &&
                <Form.Item
                    name="MasterOrSlave"
                    label={t("Master or Slave")}
                >
                    <Radio.Group onChange={(e) => setMasterOrSlave(e.target.value)} value={masterOrSlave}>
                        <Radio value={1}>{t("Master")}</Radio>
                        <Radio value={2}>{t("Slave")}</Radio>
                    </Radio.Group>
                </Form.Item>
            }
            {isSungery && addToParallel && masterOrSlave == 2 &&
                <Input.Group compact>
                    <Button>{t("ParallelMasterSN")}</Button>
                    <Form.Item
                        name="ParallelMasterID"
                        label=""
                        style={{ width: 'calc(100% - 140px' }}
                    >
                        <Select
                            showSearch
                            placeholder={t("Enter Parallel Master SN")}
                            defaultActiveFirstOption={false}
                            showArrow={false}
                            filterOption={false}
                            onSearch={handleSearchParallelMaster}
                        >{parallelMasterSelectOptions}</Select>
                    </Form.Item>
                </Input.Group>
            }
            {isSungery && addToParallel && masterOrSlave == 1 &&
                <Form.Item label={t("Add Slaves")}>
                    <Form.List name="SlaveInverters" label={t("Add Slaves")}>
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map(({ key, name, fieldKey, ...restField }) => (
                                    <Space key={key} style={{ display: 'flex', marginBottom: 2 }} align="baseline">
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'SN']}
                                            fieldKey={[fieldKey, 'SN']}
                                        >
                                            <Select
                                                showSearch
                                                placeholder={t("Enter Inveter SN")}
                                                defaultActiveFirstOption={false}
                                                showArrow={false}
                                                filterOption={false}
                                                onSearch={handleSearchInverter}
                                                style={{width: 300}}
                                            >{inverterSelectOptions}</Select>
                                        </Form.Item>
                                        <MinusCircleOutlined onClick={() => remove(name)} />
                                    </Space>
                                ))}
                                <Form.Item>
                                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />} style={{ borderRadius: '20px' }}>
                                        {t("Add Slave Inverter")}
                                    </Button>
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                </Form.Item>
            }
        </Form>
    </Modal>)
}

export default InverterAdd;